
import { useOnTimezoneChange, useSidebarPrivileges } from '@entities/viewer'

import { useTutorBillingStore } from './store'
import { useTutorBillingListApi } from '../api/list.hook'
import { isSameTutorBillingFilterQuery, queryToFilters } from '../lib/tutor-billing-query'

interface TutorBillingInfoPageReturn {
  canView: ComputedRef<boolean>
}

export const useTutorBillingInfoPage = (): TutorBillingInfoPageReturn => {
  const route = useRoute()
  const store = useTutorBillingStore()
  const { canManageTutorBilling } = useSidebarPrivileges()

  const canView = computed<boolean>(() => canManageTutorBilling.value)

  const setRefetchFromRoute = (): void => {
    store.setFilters(queryToFilters(route.query))

    void useTutorBillingListApi()
  }

  onMounted(() => {
    store.clearSelection()

    if (!canView.value) return

    void useTutorBillingListApi()
  })

  useOnTimezoneChange(() => {
    if (!canView.value) return

    setRefetchFromRoute()
  })

  watch(() => route.query, (query, oldQuery) => {
    if (!canView.value) return

    if (!isSameTutorBillingFilterQuery(query, oldQuery)) store.clearSelection()

    void useTutorBillingListApi()
  })

  watch(canView, (value, oldValue) => {
    if (!value || oldValue) return

    setRefetchFromRoute()
  })

  return {
    canView,
  }
}
